import styled from 'styled-components'

export const StyledSpecsAdvanceFilterBasicCard = styled.div``
